<template>
  <!-- 支付方式图标区域 -->
  <section class="payment-icons-section d-flex align-items-center">
    <div class="container payment-icons-container">
      <div class="row justify-content-center m-5 pb-3 title">
        <span style="color: #9a307a;">{{ title.highLight }}</span>
        {{ title.desc }}
      </div>
      <div v-for="(item, index) in list" >

        <div class="row m-5 py-3" v-if="index % 2 == 0">
          <div class="col-md-4 offset-md-2 d-flex">
            <div class="img-border d-flex justify-content-center align-items-end" :class="item.imgClass">
              <img :src="getImage(item.imgSrc)" class="img-fluid" :style="item.imgStyle">
            </div>
          </div>
          <div class="col-md-5 d-flex flex-column justify-content-center">
            <div class="subtitle">{{ item.title }}</div>
            <div class="info-container">
              <div class="info d-flex" v-for="msg in item.info">
                <div class="check-icon">
                  <img src="@/assets/uupay/icon/svg/check_right.svg" alt="">
                </div>
                <div class="desc">{{ msg.desc }}</div>
              </div>
            </div>
          </div>
        </div>

        <div class="row m-5 py-3" v-if="index % 2 == 1">
          <div class="col-md-5 offset-md-2 d-flex align-items-center">
            <div>
              <div class="subtitle">{{ item.title }}</div>
              <div class="info-container">
                <div class="info d-flex" v-for="msg in item.info">
                  <div class="check-icon">
                    <img src="@/assets/uupay/icon/svg/check_right.svg" alt="">
                  </div>
                  <div class="desc">{{ msg.desc }}</div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-md-5 d-flex justify-content-start">
            <div class="img-border d-flex justify-content-center align-items-end" :class="item.imgClass">
              <img :src="getImage(item.imgSrc)" class="img-fluid" :style="item.imgStyle">
            </div>
          </div>
        </div>

      </div>
    </div>
  </section>
</template>
<script>
export default {
  name: 'FuncFeature',
  props: {
    title: {
      type: Object,
      required: true,
    },
    list: {
      type: Array,
      required: true,
      validator: value => value.length > 0
    },
  },
  data() {
    return {
    }
  },
  computed: {
    
  },
  methods: {
    getImage(name) {
      return require(`@/assets/uupay/images/${name}.png`)
    }
  }
}
</script>
<style scoped>
.payment-icons-section {
  background-color: #fff;
  color: #21042e;
  position: relative;
  z-index: 1;
  padding: 3rem 0;
}

.payment-icons-container {
  max-width: 1440px;
}
.img-border {
  background: linear-gradient(to bottom, #c6b4c6 0%, #f3f3f4 100%);
  width: 360px;
  height: 420px;
  border-radius: 20px;
  /*border: 1px solid #f5f5f5;*/
}

.payment-icons-container .title {
  font-size: 42px;
  line-height: 60px;
  font-weight: 600;
}

.payment-icons-container .info-container {
  margin: 1rem 0;
}

.payment-icons-container .subtitle {
  font-size: 32px;
  line-height: 100%;
  font-weight: 600;
}
.payment-icons-container .info {
  font-size: 20px;
  line-height: 100%;
  font-weight: 400;
  color: #76667c;
  margin-top: 2rem;
}
.payment-icons-container .check-icon {
  margin-right: 0.8rem;
}

.payment-icons-container .payment-icon {
  width: 100%;
}
</style>


// WEBPACK FOOTER //
// src/components/FuncFeature.vue